import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Page } from '../shared';

import { fetchDealsForEmployee } from '../../actions/deals';

import ReactTooltip from 'react-tooltip';

import { Link } from 'react-router-dom';

import {
  getIcon,
  formatThousands,
  getDealCompletion,
  getDealItemsAtRisk,
  getClassModifierForConfidence,
} from '../../util';

import {
  getImperativesStages
} from '../../util/data';

class ImperativesDealFunnelPage extends Component {

  state = {
    pageMessage: null,
  }

  employeeIdFromParams(){
    const { match: { params } } = this.props;
    let employeeId = params.employeeId;

    return employeeId || null;
  }

  componentWillMount(){
    let employeeId = this.employeeIdFromParams()

    //if no employeeId...user accessing sprint
    //TODO figure out a better way of managing this
    if(employeeId){
      this.setState({
        employeeId,
        isOwnDeals: false,
      });
    }
    else{
      employeeId = this.props.user.uid;

      this.setState({
        employeeId,
        isOwnDeals: true,
      });
    }

    this.reloadDeals(employeeId);
  }

  reloadDeals(employeeId){
    this.props.fetchDealsForEmployee(employeeId || this.state.employee);
  }

  allDeals(){
    const { deals } = this.props || [];

    return _.map(deals, deal => {

      const completion = getDealCompletion(deal);
      const itemsAtRisk = getDealItemsAtRisk(deal);

      return {
        ...deal,
        completion,
        itemsAtRisk,
      }
    });
  }

  activeDeals(){
    const deals = this.allDeals();

    const activeDeals = _.filter(deals, deal => {
      return deal.completion.active;
    });

    return activeDeals;
  }

  dealStages(){
    const stages = getImperativesStages().stages;
    const { customDealStageMappingEnabled, dealStages } = this.props.organization || {};

    if(dealStages){
      return _.filter(dealStages, stage => { return stage.value !== 'Closed Won' && stage.value !== 'Closed Lost' });
    }
    else{
      return stages;
    }
  }

  renderDealForStage(deal){

    const {
      _id,
      name,
      estimatedValue,
      estimatedCloseDate,
      itemsAtRisk,
      completion,
    } = deal;

    const employeeId = this.employeeIdFromParams();

    const { confidence } = (completion || {});

    const dealConfidenceClassModifier = getClassModifierForConfidence(confidence);

    const dealLink = employeeId ? `/people/${employeeId}/imperatives/${_id}` : `/imperatives/${_id}`;

    return (
      <Link key={_id} to={dealLink} className="deal-wrap">
        <li className="deal fs-block actionable">
          <div className="deal-name">{name}</div>
          <div className="deal-primary-info">${formatThousands(estimatedValue)}</div>
          <div className="deal-secondary-info">{moment(estimatedCloseDate).format('MM/DD/YY')}</div>

          {itemsAtRisk && itemsAtRisk.length > 0 &&
            <React.Fragment>
              <div data-for={`deal-${_id}-items-at-risk-count-tooltip`} data-tip={`Deal has ${itemsAtRisk.length} item${itemsAtRisk.length !== 1 ? 's' : ''} at risk`} className="deal-at-risk">{getIcon('warning')}<div className="count">{itemsAtRisk.length}</div></div>
              <ReactTooltip id={`deal-${_id}-items-at-risk-count-tooltip`} effect="solid" place="top" />
            </React.Fragment>
          }

          <div className="deal-confidence-label">
            <div className={`dial confidence-${dealConfidenceClassModifier}`} style={{width: '60px', height: '60px'}}>
              <div className="dial__progress" data-percent={confidence}></div>
              <div className="dial__content" style={{lineHeight: '50px'}}>{confidence}</div>
              <div className="dial__denominator">/100</div>
            </div>
          </div>
        </li>
      </Link>
    )
  }

  renderStage(stage, stageIndex){
    const { label, value } = stage;

    const dealsForStage = _.filter(this.activeDeals(), { stage: value });

    const stageValue = _.reduce(dealsForStage || [], (memo, deal) => {
      return memo + deal.estimatedValue;
    }, 0);

    const stageHasDeals = dealsForStage && dealsForStage.length > 0;

    return (
      <div
        key={value}
        className={`stage`}
      >
        <div className="stage-name">{label} ({dealsForStage && dealsForStage.length})</div>

        {dealsForStage &&
          <div className="stage-value">${formatThousands(stageValue)}</div>
        }

        {stageHasDeals &&
          <ul className="deals-for-stage">
            {_.map(dealsForStage, this.renderDealForStage.bind(this))}
          </ul>
        }
        {!stageHasDeals &&
          <div className="no-deals-for-stage">No deals in {label} stage.</div>
        }
        {(stageIndex < this.dealStages().length - 1) &&
          <div className="arrow-to-next-stage">{getIcon('chevron-down')}</div>
        }
      </div>
    );
  }

  renderDealsByStage(){

    const stages = this.dealStages();

    return(
      <div className="page-content deal-funnel-view">
        <div className="page-section">
          <div className="buying-stage">
            <div className="stages">
              {_.map(stages, this.renderStage.bind(this))}
            </div>
          </div>
        </div>
      </div>
    )
  }

  render(){

    const loading = !this.props.user;

    return (
      <Page
        pageClass="imperatives active"
        loading={loading}
        pageMessage={this.state.pageMessage}
        clearMessage={() => { this.setState({ pageMessage: null }) }}
      >
        {this.renderDealsByStage()}
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    deals: state.deals.data,
    viewingUser: state.viewingUser.data,
    organization: state.organization.data,
  }
}

export default connect(mapStateToProps, { fetchDealsForEmployee })(ImperativesDealFunnelPage);



// WEBPACK FOOTER //
// ./src/components/imperatives/funnel.js